var __jsx = React.createElement;
import React from 'react';
import { ErrorContainer, ErrorHeading } from "./style";
var CardErrorMessage = function CardErrorMessage(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return __jsx(ErrorContainer, null, __jsx(ErrorHeading, null, title), children);
};
export default CardErrorMessage;